import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { User, useUsers } from '@/api/hooks/useUsers'
import { StateSwitcher } from '@/components/atoms/state-switcher'
import PageLayout from '@/components/layout/page-layout'
import UsersTable from '@/components/organisms/users-table'
import { BatchImportUsersDialog } from '@/components/organisms/users-table/batch-import-users-dialog'
import { CreateInvitationDialog } from '@/components/organisms/users-table/create-invitation-dialog'
import { UpdateUserDialog } from '@/components/organisms/users-table/update-user-dialog'

export const Route = createFileRoute('/_authenticated/users/')({
  component: UsersPage,
})

function UsersPage() {
  const { t } = useTranslation()
  const { data: users = [], isError, isLoading } = useUsers()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [editing, setEditing] = useState<User | undefined>()

  const openUser = (user: User) => {
    setEditing(user)
    setDialogOpen(true)
  }

  return (
    <PageLayout title={t('global.user_plural')}>
      <StateSwitcher isError={isError} isLoading={isLoading}>
        <UsersTable
          actions={
            <>
              <BatchImportUsersDialog />
              <CreateInvitationDialog />
            </>
          }
          users={users}
          onEditUser={openUser}
        />
      </StateSwitcher>
      <UpdateUserDialog open={dialogOpen} onOpenChange={setDialogOpen} user={editing} />
    </PageLayout>
  )
}
